// extracted by mini-css-extract-plugin
export default {"font-renta":"WarehouseTaskHoursPanel_font-renta__fP-LW","taskHoursPanel":"WarehouseTaskHoursPanel_taskHoursPanel__xOwoT","grid":"WarehouseTaskHoursPanel_grid__Bx-Zi"};